import directives from './module';
import {Utils} from 'underscore-extensions';
import {PlayerSvc} from '../services/PlayerSvc';

export const removeHtmlClass = () => document.documentElement.classList.remove('modal-shown');

directives.directive('modalDialog', function ($timeout: ng.ITimeoutService,
                                              $rootScope: ng.IRootScopeService,
                                              $compile: ng.ICompileService,
                                              $animate: any,
                                              PlayerSvc: PlayerSvc) {
    const animationClass = 'animation';
    return {
        restrict: 'EA',
        scope: {
            show: '=',
            isScroll: '<?',
            outside: '<',
            dialogTitle: '@',
            onClose: '&?',
            onClickOutside: '&?',
            modalUrl: '@',
            additionalClasses: '@',
            onChange: '&?',
            disableClickOutside: '=?',
            directive: '@'
        },
        transclude: true,
        templateUrl: require('modal-template.html'),

        link: function (this: any, scope: any, element: ng.IAugmentedJQuery, attrs: any, ctrl: any, transclude: any) {
            let modalEl: ng.IAugmentedJQuery;
            let directiveScope: ng.IScope = scope.$new(true);
            const container               = scope.outside ? angular.element(document.querySelector('.wrapper')) : element;
            const modalTemplate           = element[0].firstElementChild;
            element[0].removeChild(element[0].firstElementChild);

            const appendModal = () => {
                modalEl = $compile(angular.copy(modalTemplate))(scope);
                container.append(modalEl);
            };

            const close = () => animationClose(() => {
                if (!attrs.hasOwnProperty('dontAutoClose')) scope.show = false;
                if (_.isFunction(scope.onClickOutside)) scope.onClickOutside();
                _.isFunction(scope.onClose) && scope.onClose();
                removeHtmlClass();
                modalEl.remove();
                $rootScope.$emit('modal:close');
            });

            const stateChangeSuccessOff = $rootScope.$on('$stateChangeStart', () => {
                removeHtmlClass();
            });
            scope.$on('$destroy', () => {
                stateChangeSuccessOff();
                modalEl && modalEl.remove();
            });

            scope.closeButton = typeof attrs.closeButton === 'string';

            const animatedEl = (f: (e: Element) => void) => modalEl[0] && f(modalEl[0]);

            const animationClose = (callback: Function) => {
                const onceExecuted = _.once(callback).bind(this);
                animatedEl((el: HTMLElement) => {
                    el.addEventListener('transitionend', e => scope.$apply(() => onceExecuted()));
                    Utils.rAF(() => el.classList.remove(animationClass));
                });
            };
            scope.includeLoaded = () => Utils.rAF(() => animatedEl(e => e.classList.add(animationClass)));

            scope.hideModal = (e: MouseEvent) => {
                const target = <HTMLElement>e.target;
                if ((!scope.disableClickOutside && target === modalEl[0].querySelector('.ng-modal-overlay'))
                    || target === modalEl[0].querySelector('.ng-modal-close')) {

                    if (!attrs.hasOwnProperty('dontAutoClose')) {
                        scope.show = false;
                    } else {
                        close();
                    }

                    e.stopPropagation();
                    e.preventDefault();
                }
            };

            if (!scope.disableClickOutside) {
                const isInput = () => document.activeElement.getAttribute('contenteditable')
                || document.activeElement.tagName.toLowerCase() === 'input';
                Utils.scopedEvent('keydown', scope, (e: KeyboardEvent) => {
                    if (scope.show && (e.keyCode || e.which) === 27 && !isInput()) {
                        close();
                    }
                }, document, true);
            }

            scope.$watch('show', (newVal: boolean, oldVal: boolean) => {
                if (options.isPhantom) return;

                directiveScope.$destroy();
                if (angular.isFunction(scope.onChange) && scope.onChange()) {
                    scope.onChange()(newVal, oldVal);
                }
                if (!newVal && oldVal) {
                    close();
                } else if (newVal && !scope.modalUrl) {
                    document.documentElement.classList.add('modal-shown');
                    appendModal();
                    $rootScope.$emit('modal:show');

                    if (scope.directive) {
                        directiveScope = scope.$new(true);
                        const compiled = $compile(document.createElement(scope.directive))(directiveScope);
                        $animate.enter(compiled, null, modalEl.find('transclude-directive')).then(() => {
                            $timeout(() => scope.includeLoaded());
                        });
                    } else {
                        transclude((el: ng.IAugmentedJQuery) => {
                            angular.element(modalEl[0].querySelector('.ng-modal-dialog-content')).append(el);
                            $timeout(() => scope.includeLoaded());
                        });
                    }
                }
                !_.isUndefined(newVal) && togglePlayers(newVal);
            });

            function togglePlayers(modalOpened: boolean) {
                PlayerSvc.instances().forEach(p => {
                    if (modalOpened && p.isPlaying()) {
                        p.pause();
                        p._pauseBecauseOfModal = true;
                    } else if (!modalOpened && p._pauseBecauseOfModal) {
                        p._pauseBecauseOfModal = false;
                        p.play();
                    }
                });
            }
        }
    };
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/modalDialogDirective.ts